import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="py-20 md:py-28 bg-primary-800">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-3xl mx-auto text-center">
          <div className="w-16 h-1 bg-accent-500 mx-auto rounded-full mb-6" />
          <h2 className="text-2xl md:text-4xl font-bold text-background-50 font-heading mb-4">
            Pronto para transformar sua instituição?
          </h2>
          <p className="text-background-200 text-base md:text-lg mb-10 leading-relaxed">
            Entre em contato conosco e descubra como nossas soluções podem modernizar a gestão da sua escola.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <Link
              to="/contato"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-accent-500 text-background-50 text-sm font-semibold hover:bg-accent-600 transition-colors whitespace-nowrap"
            >
              Entre em Contato
            </Link>
            <a
              href="https://wa.me/5583998460015"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-background-50/10 text-background-50 text-sm font-semibold hover:bg-background-50/20 transition-colors whitespace-nowrap flex items-center justify-center gap-2 border border-background-50/30"
            >
              <i className="ri-whatsapp-line" />
              WhatsApp Comercial
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}